/**
 * 이미지
 */
import { useState, useCallback, Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, FILTER_DATA, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import FilterWrap from '@components/contents/common/FilterWrap';
import { useOption } from '@hooks/useOption';
import ImageArticle from '@components/contents/article/ImageArticle';
import Paging from '@components/contents/common/Paging';
import Modal, { type IModal } from '@components/contents/common/Modal';
import type { IContentData, IImage, ILoaderData } from '@type/index';

export const ImageLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<IImage | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.IMAGE));

    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.IMAGE, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getImage?.initiate({ option, params: searchParams }));
  };

interface IFilterComponentProps {
  count: number;
}
const FilterComponent = ({ count }: IFilterComponentProps) => {
  const { serviceAlias } = useOption();

  return (
    <Header totalCount={count}>
      <FilterWrap filterDataObj={serviceAlias ? FILTER_DATA[serviceAlias][ALIAS.IMAGE] : {}} />
    </Header>
  );
};

interface IContentComponentProps {
  data: IContentData<IImage>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [modalData, setModalData] = useState<IModal['data']>({ url: null, title: null });

  const imageClickCallback = useCallback((modalData: IModal['data']) => {
    setIsOpen(true);
    setModalData(modalData);
  }, []);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-4">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <ImageArticle item={item} l10n={l10n!} imageClickCallback={imageClickCallback} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
      <Modal type="image" isOpen={isOpen} setIsOpen={setIsOpen} data={modalData} />
    </Fragment>
  );
};

const Image = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<IImage>>) || {};

  console.log('Image Data', useLoaderData());

  return (
    <div className="search-result image">
      <FilterComponent count={data?.pagination?.total} />
      {!isError && Array.isArray(data?.list) && data?.list?.length > 0 ? <ContentComponent data={data} /> : <NoData />}
    </div>
  );
};

export default Image;
